import get from 'lodash/get';

export function isPerformanceEnabledSelector(state) {
  const marketingRegion =
    get(state, 'application.setup.marketingRegion') ||
    get(state, 'playbackSession.marketingRegion');
  if (['us', 'latam'].indexOf(marketingRegion) !== -1) {
    return true;
  }
  return get(state, 'applicationinternal.consentSettings.performance');
}
